// extracted by mini-css-extract-plugin
module.exports = {"rootSizeOverlay":"VkBom","desktop":"Itiil","mobile":"MOvr1","rootSizeOverlayDesc":"EdAH8","overlayDescription":"VFhSP"};